import { Briefcase, Cloud, Compass, DollarSign, Home, Pickaxe, Trophy } from 'lucide-react'
import { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'

export default function Sidebar() {
  const location = useLocation()

  // Sidebar durumunu localStorage'dan yukle - initial state olarak
  const [collapsed, setCollapsed] = useState(() => {
    const saved = localStorage.getItem('sidebar-collapsed')
    return saved === 'true'
  })

  // Dil durumunu localStorage'dan yukle - initial state olarak
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('filiz_lang') || 'en'
  })

  // Sidebar durumunu DOM'a uygula
  useEffect(() => {
    if (collapsed) {
      document.body.classList.add('sidebar-collapsed')
    } else {
      document.body.classList.remove('sidebar-collapsed')
    }
  }, [collapsed])

  // Sidebar toggle
  const toggleSidebar = () => {
    const newState = !collapsed
    setCollapsed(newState)
    localStorage.setItem('sidebar-collapsed', newState ? 'true' : 'false')

    if (newState) {
      document.body.classList.add('sidebar-collapsed')
      document.body.classList.remove('sidebar-hidden')
    } else {
      document.body.classList.remove('sidebar-collapsed')
      document.body.classList.remove('sidebar-hidden')
    }
  }

  // Dil degistir
  const handleLanguageChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newLang = e.target.value
    setLanguage(newLang)
    localStorage.setItem('filiz_lang', newLang)
    window.location.reload()
  }

  // Aktif link kontrolu
  const isActive = (path: string) => {
    if (path === '/projects') {
      return location.pathname === '/projects' || location.pathname === '/'
    }
    return location.pathname === path
  }

  // Nav item'lari
  const navItems = [
    { icon: Home, label: 'Projeler', href: '/projects' },
    { icon: Briefcase, label: 'Work', href: '/work' },
    { icon: Compass, label: 'Kesfet', href: '/discover' },
    { icon: Cloud, label: 'Cloud', href: '/cloud' },
    { icon: Pickaxe, label: 'Mining', href: '/petals-mining' },
    { icon: Trophy, label: 'Liderboard', href: '/leaderboard' },
    { icon: DollarSign, label: 'Ekonomi', href: '/economics-v2' }
  ]

  return (
    <aside
      className={`sidebar ${collapsed ? 'collapsed' : ''}`}
      id="sidebarNav"
      role="navigation"
      aria-label="Sidebar navigation"
    >
      {/* Sidebar header - FW gradient logo */}
      <div className="sidebar-header">
        <Link
          to="/"
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            textDecoration: 'none',
            color: 'inherit',
            width: '100%'
          }}
        >
          <div
            style={{
              width: '30px',
              height: '30px',
              minWidth: '30px',
              borderRadius: '50%',
              background: 'linear-gradient(135deg, #1e40af, #7c3aed)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '10px',
              fontWeight: 700,
              color: '#fff'
            }}
          >
            FW
          </div>
          <span className="logo-text">Filiz AI Worker</span>
        </Link>
      </div>

      {/* Nav linkleri */}
      <nav className="sidebar-nav" id="sidebarNavLinks">
        {navItems.map((item) => {
          const Icon = item.icon
          const active = isActive(item.href)

          return (
            <Link
              key={item.href}
              to={item.href}
              className={`sidebar-nav-item ${active ? 'active' : ''}`}
            >
              <span
                className="nav-icon"
                style={{
                  fontSize: '18px',
                  width: '24px',
                  textAlign: 'center',
                  flexShrink: 0,
                  lineHeight: 1,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <Icon size={18} />
              </span>
              <span className="nav-label">{item.label}</span>
            </Link>
          )
        })}
      </nav>

      {/* Sidebar footer - dil secici */}
      <div className="sidebar-footer" id="sidebarFooter">
        <div id="sidebarLangSwitcher">
          <select
            className="sidebar-lang"
            id="sidebarLangSelect"
            aria-label="Language"
            value={language}
            onChange={handleLanguageChange}
          >
            <option value="en">English</option>
            <option value="tr">Turkce</option>
            <option value="de">Deutsch</option>
            <option value="fr">Francais</option>
            <option value="es">Espanol</option>
            <option value="ar">Al-Arabiyyah</option>
            <option value="zh">Zhongwen</option>
            <option value="ja">Nihongo</option>
            <option value="ko">Hangugeo</option>
            <option value="ru">Russkiy</option>
          </select>
        </div>
      </div>

      {/* Toggle butonu - altta, border + card-bg */}
      <button
        className="sidebar-toggle-bottom"
        id="sidebarToggle"
        aria-label="Toggle sidebar"
        title="Toggle sidebar"
        onClick={toggleSidebar}
      >
        <span className="sidebar-toggle-text">← Kapat</span>
        <span className="sidebar-toggle-icon">→</span>
      </button>
    </aside>
  )
}
